import axios from "axios";

export const itemdimensionanalysisService = {
    fetchItemDetails,
    fetchItemSummary
};

function fetchItemDetails(item) {
  try {
    const response = axios.get(
      process.env.REACT_APP_SERVER_URL + "v1/itemresource/item/" + item
    );
    return response;
  } catch (error) {
    throw error;
  }
}

function fetchItemSummary(item) {
  try {
    const response = axios.get(
      process.env.REACT_APP_SERVER_URL + "v1/itemresource/item/summary/" + item
    );
    return response;
  } catch (error) {
    throw error;
  }
}